<template>
    <div class="grid grid-cols-12">
        <div ref="panels" class="order-2 lg:order-1 col-span-12 lg:col-span-4 relative">
            <div
                v-for="(item, i) in items"
                :key="`item-${i}`"
                class="panel relative rounded-br-3xl rounded-bl-3xl lg:rounded-br-none lg:rounded-tl-3xl lg:rounded-bl-3xl"
                :style="`z-index: ${items.length - i}`"
            >
                {{/* This component is based on the primevue accordion component. */}}
                <button
                    :id="`type-5_tab-${i + 1}-header`"
                    tabindex="0"
                    :aria-expanded="activeIndex === i ? 'true' : 'false'"
                    :aria-controls="`type-5_tab-${i + 1}-content`"
                    class="accordion-header cursor-pointer"
                    @click="activeIndex = i"
                    @keyup.enter="activeIndex = i"
                >
                    <span v-if="item.title" class="font-Poppins font-bold">
                        <span aria-hidden="true">{{ i + 1 }}</span
                        >&nbsp;&nbsp;{{ item.title }}
                    </span>
                    <i
                        class="pi pi-chevron-down transition-transform"
                        :class="{ '-rotate-180': activeIndex === i }"
                    ></i>
                </button>
                <div
                    :id="`type-5_tab-${i + 1}-content`"
                    :aria-labelledby="`type-5_tab-${i + 1}-header`"
                    class="type-5-panel overflow-hidden relative transition-all"
                    :style="`height: ${activeIndex === i ? tallestPanelContentHeight + 'px' : 0}`"
                >
                    <div class="absolute">
                        <div class="type-5-panel__content">
                            <div class="h-1 border-b border-black mx-6"></div>
                            <div class="pt-4 pb-6 px-6 whitespace-pre-line" v-html="item.description"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="order-1 lg:order-2 col-span-12 lg:col-span-8 relative">
            <div
                class="relative h-full min-h-[250px] sm:min-h-[350px] md:min-h-[400px] lg:min-h-0 rounded-tl-2xl rounded-tr-2xl lg:rounded-tl-none lg:rounded-tr-3xl lg:rounded-br-3xl overflow-hidden"
            >
                <img
                    v-for="(item, i) in items"
                    :key="`item-${i}`"
                    :src="item.src"
                    :alt="item.title || `${$t('generic.gallery_image_alt_text')} ${i}`"
                    class="absolute w-full h-full object-cover transition-opacity"
                    :class="activeIndex === i ? 'opacity-100 z-1 delay-0' : 'opacity-0 z-0 delay-200'"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Type5Block',
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            activeIndex: 0,
            tallestPanelContentHeight: 0,
        };
    },
    watch: {
        '$store.state.windowWidth'() {
            this.setTallestPanelContentHeight();
            this.setPanelContentMaxHeight();
        },
    },
    mounted() {
        this.setTallestPanelContentHeight();
        this.setPanelContentMaxHeight();
    },
    methods: {
        setTallestPanelContentHeight() {
            const panels = Array.from(this.$refs.panels.children);
            let highestValue = 0;

            panels.forEach((panel) => {
                const _panelHeight = panel.querySelector('.type-5-panel__content').getBoundingClientRect().height;

                if (highestValue < _panelHeight) {
                    highestValue = _panelHeight;
                }
            });

            this.tallestPanelContentHeight = highestValue;
        },
        setPanelContentMaxHeight() {
            const panels = Array.from(this.$refs.panels.children);
            panels.forEach((panel) => {
                const $panel = panel.querySelector('.type-5-panel');

                if (this.$store.state.windowWidth >= 1024) {
                    $panel.style.maxHeight = 'unset';
                    return;
                }

                const _panelContentScrollHeight = panel.querySelector('.type-5-panel__content').scrollHeight;
                $panel.style.maxHeight = _panelContentScrollHeight + 'px';
            });
        },
    },
};
</script>

<style scoped>
.accordion-header {
    @apply flex justify-between items-center px-6 pt-6 pb-4;
}

.panel {
    &:not(:first-child)::before {
        content: '';
        left: 0;
        z-index: -1;
        @apply block absolute w-full h-14 left-0 -top-5;
    }
    &:nth-child(3n + 1),
    &:nth-child(3n + 1)::before {
        @apply bg-white;
    }
    &:nth-child(3n + 2),
    &:nth-child(3n + 2)::before {
        background-color: #c8c8c8;
    }
    &:nth-child(3n + 3),
    &:nth-child(3n + 3)::before {
        @apply bg-yellow-400;
    }
}
</style>
